export const MAIN_PASS_SCORE = 10;
export const MAIN_FAIL_SCORE_NORMAL = -25;
export const MAIN_FAIL_SCORE_LAST = -100;
export const SUB_BONUS_SCORE = 5;
